import { resolveFragment } from "@ext/markdown/elements/fragment/logic/resolveFragment";
import type PrivateParserContext from "../../../../core/Parser/ParserContext/PrivateParserContext";
import { type Node, type Schema, SchemaType, Tag } from "../../../../core/render/logic/Markdoc/index";

export function fragment(context: PrivateParserContext): Schema {
	return {
		render: "Fragment",
		type: SchemaType.block,
		attributes: { id: { type: String } },

		transform: async (node: Node) => {
			const { id, type, branch } = node.attributes;
			const fragmentData = await resolveFragment(context, { id, type, branch });
			return new Tag("Fragment", { ...fragmentData, type, branch }, fragmentData.content ?? []);
		},
	};
}
